import React, { useState } from 'react';
import './RoadmapSection.css';

const RoadmapSection = () => {
  const [hoveredIndex, setHoveredIndex] = useState(-1);

  const steps = [
    {
      day: "DAY 1 - 10",
      title: "Fundamentals",
      desc: "Java basics, Syntax, Variables, OOPS concepts (Inheritance, Polymorphism), and Method Overloading."
    },
    {
      day: "DAY 11 - 20",
      title: "Intermediate Java",
      desc: "Strings, Wrapper classes, Exception handling, and Collections framework (ArrayList, HashMap)."
    },
    {
      day: "DAY 21 - 30",
      title: "Advanced Core Java",
      desc: "Multi-threading, Synchronization, Java 8 features (Lambda, Streams), and Date & Time API."
    },
    {
      day: "DAY 31 - 40",
      title: "SuperX Implementation",
      desc: "Real-time project development, Logic building, Modular structure, and Industry workflow."
    },
    {
      day: "DAY 41 - 45",
      title: "Interview Prep",
      desc: "Mock interviews, Coding challenges, Aptitude, Resume building, and HR/Technical preparation."
    }
  ];

  return (
    <section className="ucp-section ucp-roadmap">
      <div className="roadmap-container">
        <div className="roadmap-header">
          <div className="header-left">
            <span className="label">THE JOURNEY</span>
            <h2 className="section-title">Success <span className="blue-text">Roadmap</span></h2>
          </div>
          <div className="header-right">
            <p>A structured 45-day path designed to take you from a learner to an enterprise-ready professional.</p>
          </div>
        </div>

        <div className="roadmap-visual" onMouseLeave={() => setHoveredIndex(-1)}>
          <div className="timeline-line">
            <div 
              className="timeline-progress"
              style={{ width: hoveredIndex !== -1 ? `${(hoveredIndex / 4) * 100}%` : '0%' }}
            ></div>
          </div>
          <div className="steps-grid">
            {steps.map((step, index) => {
              // Determine background color of the circle
              let circleColor = "#475569";
              if (hoveredIndex === -1) {
                if (index === 0) circleColor = "var(--accent-main)";
                if (index === 4) circleColor = "#10B981";
              } else {
                if (index <= hoveredIndex) {
                  circleColor = index === 4 ? "#10B981" : "var(--accent-main)";
                }
              }

              const isActive = hoveredIndex !== -1 && index <= hoveredIndex;

              return (
                <div 
                  key={index} 
                  className={`step-item ${isActive ? 'active' : ''}`}
                  onMouseEnter={() => setHoveredIndex(index)}
                >
                  <div className="step-circle" style={{ backgroundColor: circleColor }}>
                    {index + 1}
                  </div>
                  <div className="step-info">
                    <span className="step-day" style={{ color: index === 4 ? '#10B981' : 'var(--accent-main)' }}>
                      {step.day}
                    </span>
                    <h3 className="step-title">{step.title}</h3>
                    <p className="step-desc">{step.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default RoadmapSection;
